import { ConfigProvider } from "antd"
import { ReactNode } from "react"

export const SplitterProvider = ({ children }: { children: ReactNode }) => {
	return (
		<ConfigProvider
			theme={{
				token: {
					controlItemBgActive: "transparent",
					controlItemBgHover: "transparent",
					controlItemBgActiveHover: "transparent",
				},
				components: {
					Splitter: {
						splitBarDraggableSize: 30,
						splitBarSize: 4,
						splitTriggerSize: 30,
					},
				},
			}}
		>
			{children}
		</ConfigProvider>
	)
}
